export const Footer = () => {
	// Email obfuscation by splitting and using CSS to prevent easy scraping
	const emailUser = 'hey';
	const emailDomain = 'onedaymvp.com';
	
	return (
		<footer className="mt-24 py-12 border-t border-white/10">
			<div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-8">
				<div>
					<h4 className="font-bold mb-4">OneDayMVP</h4>
					<p className="text-sm text-gray-400">
						Transform your ideas into reality at lightning speed with our AI-powered MVP development platform.
					</p>
				</div>
				<div>
					<h4 className="font-bold mb-4">Contact</h4>
					<p className="text-sm text-gray-400">
						<span className="email-user">{emailUser}</span>
						<span className="hidden">no-spam</span>
						@
						<span className="email-domain">{emailDomain}</span>
					</p>
				</div>
			</div>
		</footer>
	);
};
